import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../redux/types'

function CustomTextField({
  multiline = false,
  label = '',
  inputName,
  value,
  handleInputChange,
  required = false,
  error = false,
  errorMsg = ''
}: any) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)

  return (
    <TextField
      id={`txt-input-${inputName}`}
      label={label ? t(label) : t(inputName)}
      value={value ?? ''}
      multiline={multiline}
      required={required}
      error={errorForm[inputName] || error}
      helperText={msgForm[inputName] || errorMsg ? t(`admin.people.${errorMsg}`) : ''}
      onChange={e => handleInputChange(inputName, e.target.value)}
      InputLabelProps={{ shrink: true }}
      variant="filled"
      fullWidth
    />
  )
}

export default CustomTextField
